import { render, staticRenderFns } from "./EditFun.vue?vue&type=template&id=7601e15c&"
import script from "./EditFun.vue?vue&type=script&lang=js&"
export * from "./EditFun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports